import React from "react";
import BtnArrow from "./../../assets/images/ArrowUpRight.png";
import "./contact.css";
const Contact = ({ contact }) => {
  return (
    <div className="contact" id="contact" ref={contact}>
      <div className="contact_left">
        <p className="contact_heading">Love to Here from you, Get in touch👋</p>
        <div>
          <div className="input_row">
            <div className="input_container">
              <label>First Name</label>
              <input type="text" placeholder="Aryna" />
            </div>
            <div className="input_container">
              <label>Last Name</label>
              <input type="text" placeholder="Sebalenka" />
            </div>
          </div>
          <div className="input_row">
            <div className="input_container">
              <label>Email</label>
              <input type="text" placeholder="aryna@gmail.com" />
            </div>
            <div className="input_container">
              <label>Mobile Phone</label>
              <input type="text" placeholder="Phone" />
            </div>
          </div>
          <div className="input_row">
            <div className="input_container">
              <label>Message</label>
              <textarea rows={5}></textarea>
            </div>
          </div>

          <div className="contact_btn_container">
              <button>
                Just Send <img src={BtnArrow} alt="" />
              </button>
            
          </div>
        </div>
      </div>
      <div className="contact_spacer"/>
      <div className="contact_right">
        <p className="contact_heading" style={{padding:'20px 0'}}>Thank you for your intrests.</p>
        <p className="contact_text">
          We are doing our best to make you happy and beauty, our team will try
          to get back to you as soon as possible.
        </p>
        <p className="contact_text">for direct contact please send us email to info@mixybeauty.com. </p>
      </div>
    </div>
  );
};

export default Contact;
